import * as React from 'react';
import { GridColumnMenuFilter, GridColumnMenuCheckboxFilter, GridColumnMenuProps } from '@progress/kendo-react-grid';

export const ColumnMenu = (props: GridColumnMenuProps) => {
    return (
        <div>
            <GridColumnMenuFilter {...props} expanded={true} />
        </div>
    );
};

interface ColumnMenuCheckboxFilterProps extends GridColumnMenuProps {
    data: any[];
}

export const ColumnMenuCheckboxFilter = (props: ColumnMenuCheckboxFilterProps) => {
    const { data, ...rest } = props;
    return (
        <div>
            <GridColumnMenuCheckboxFilter {...rest} data={data} expanded={true} />
        </div>
    );
};
